import PropTypes from 'prop-types';
import React from 'react';

const Loading = ({ loadingText, error }) => {
  return (
    <div className="loading-robot slide-in-blurred-top">
      <div className="loading__backdrop" />
      <div className="loading__wrapper">
        {!error ? (
          <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100">
            <g class="robot">
              <path
                fill="#E2E1E1"
                d="M57.137,24.052H37.16c-3.218,0-5.987,2.278-6.606,5.436l-2.766,14.099
		c-0.223,1.137,0.648,2.195,1.806,2.195h35.109c1.159,0,2.03-1.058,1.806-2.195l-2.766-14.099
		C63.124,26.33,60.356,24.052,57.137,24.052z"
              />
              <g>
                <path
                  fill="#C1C5C5"
                  d="M54.564,37.912c-2.197,0-3.985-1.787-3.985-3.985c0-2.197,1.787-3.985,3.985-3.985
			c2.197,0,3.985,1.787,3.985,3.985C58.549,36.124,56.761,37.912,54.564,37.912z"
                />
                <g>
                  <path
                    fill="#5F5F5F"
                    d="M54.564,30.795c1.727,0,3.132,1.405,3.132,3.132s-1.405,3.132-3.132,3.132s-3.132-1.405-3.132-3.132
				S52.837,30.795,54.564,30.795 M54.564,29.09c-2.672,0-4.837,2.166-4.837,4.837c0,2.672,2.166,4.837,4.837,4.837
				c2.672,0,4.837-2.166,4.837-4.837C59.401,31.256,57.235,29.09,54.564,29.09L54.564,29.09z"
                  />
                </g>
              </g>
              <g>
                <circle fill="#E2E1E1" cx="55.954" cy="34.856" r="1.509" />
              </g>
              <circle fill="#888989" cx="47.003" cy="42.638" r="1.871" />
              <g>
                <path
                  fill="#888989"
                  d="M39.603,37.912c-2.197,0-3.985-1.787-3.985-3.985c0-2.197,1.787-3.985,3.985-3.985
			c2.197,0,3.985,1.787,3.985,3.984S41.8,37.912,39.603,37.912z"
                />
                <path
                  fill="#5F5F5F"
                  d="M39.603,30.795c1.727,0,3.132,1.405,3.132,3.132s-1.405,3.132-3.132,3.132s-3.132-1.405-3.132-3.132
			S37.876,30.795,39.603,30.795 M39.603,29.09c-2.672,0-4.837,2.166-4.837,4.837c0,2.672,2.166,4.837,4.837,4.837
			s4.837-2.166,4.837-4.837C44.44,31.256,42.275,29.09,39.603,29.09L39.603,29.09z"
                />
              </g>
              <g>
                <circle fill="#E2E1E1" cx="40.972" cy="34.856" r="1.509" />
              </g>
              <g>
                <circle fill="#E2E1E1" cx="42.481" cy="38.764" r="1.509" />
              </g>
              <path
                fill="#5F5F5F"
                d="M34.767,66.281c-0.523,0-1.031-0.276-1.304-0.765L26.45,52.961c-0.402-0.719-0.144-1.628,0.575-2.03
		c0.72-0.402,1.628-0.144,2.03,0.575l7.013,12.555c0.402,0.719,0.144,1.629-0.575,2.03C35.263,66.22,35.014,66.281,34.767,66.281z"
              />
              <path
                fill="#5F5F5F"
                d="M27.752,53.726c-0.303,0-0.61-0.092-0.874-0.284c-0.667-0.483-0.816-1.416-0.332-2.084l8.65-11.934
		c0.484-0.667,1.416-0.816,2.084-0.332c0.667,0.484,0.816,1.416,0.332,2.084l-8.65,11.934
		C28.669,53.512,28.214,53.726,27.752,53.726z"
              />
              <path
                fill="#5F5F5F"
                d="M59.267,64.602c-0.45,0-0.894-0.202-1.188-0.588c-0.499-0.655-0.373-1.592,0.283-2.091l11.723-8.934
		c0.655-0.5,1.592-0.373,2.091,0.283c0.499,0.655,0.373,1.592-0.283,2.091L60.17,64.297C59.9,64.503,59.582,64.602,59.267,64.602z"
              />
              <path
                fill="#E2E1E1"
                d="M62.006,77.856c0,1.413-1.145,2.558-2.558,2.558h-24.6c-1.413,0-2.558-1.145-2.558-2.558v-24.6
		c0-1.413,1.145-2.558,2.558-2.558h24.6c1.413,0,2.558,1.145,2.558,2.558L62.006,77.856L62.006,77.856z"
              />
              <path
                fill="#BCBCBB"
                d="M37.928,61.192h18.44c0.843,0,1.526-0.683,1.526-1.526v-2.045c0-0.843-0.683-1.526-1.526-1.526h-18.44
		c-0.843,0-1.526,0.683-1.526,1.526v2.045C36.402,60.508,37.086,61.192,37.928,61.192z"
              />
              <path
                fill="#BCBCBB"
                d="M37.928,75.092h18.44c0.843,0,1.526-0.683,1.526-1.526v-7.374c0-0.843-0.683-1.526-1.526-1.526h-18.44
		c-0.843,0-1.526,0.683-1.526,1.526v7.374C36.402,74.41,37.086,75.092,37.928,75.092z"
              />
              <path
                fill="#ff5322"
                d="M40.298,58.597v0.093c0,0.384-0.311,0.695-0.695,0.695s-0.695-0.311-0.695-0.695v-0.093
		c0-0.384,0.311-0.695,0.695-0.695C39.987,57.901,40.298,58.213,40.298,58.597z"
              />
              <path
                class="color"
                fill="#f05432"
                d="M52.691,58.597v0.093c0,0.384-0.311,0.695-0.695,0.695s-0.695-0.311-0.695-0.695v-0.093
		c0-0.384,0.311-0.695,0.695-0.695C52.379,57.901,52.691,58.213,52.691,58.597z"
              />
              <path
                class="color2"
                fill="#f91b6b"
                d="M55.954,58.597v0.093c0,0.384-0.311,0.695-0.695,0.695s-0.695-0.311-0.695-0.695v-0.093
		c0-0.384,0.311-0.695,0.695-0.695C55.643,57.901,55.954,58.213,55.954,58.597z"
              />
              <g>
                <circle fill="#C1C5C5" cx="37.588" cy="37.739" r="8.072" />
                <path
                  fill="#5F5F5F"
                  d="M37.588,47.517c-5.391,0-9.778-4.386-9.778-9.778s4.386-9.778,9.778-9.778s9.778,4.386,9.778,9.778
			S42.98,47.517,37.588,47.517z M37.588,31.372c-3.511,0-6.367,2.856-6.367,6.367s2.856,6.367,6.367,6.367s6.367-2.856,6.367-6.367
			S41.099,31.372,37.588,31.372z"
                />
              </g>
              <g>
                <circle class="eyes" fill="#E2E1E1" cx="40.298" cy="38.026" r="2.24" />
              </g>
            </g>
            <ellipse class="shadow" fill="#F4F4F4" cx="47.149" cy="86.125" rx="13.384" ry="2.152" />
          </svg>
        ) : (
          <svg viewBox="0 0 599 632" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M387.798 29.8746H200.668C170.524 29.8746 144.586 53.2005 138.788 85.5372L112.878 229.906C110.789 241.548 118.948 252.382 129.796 252.382H458.67C469.527 252.382 477.686 241.548 475.587 229.906L449.678 85.5372C443.879 53.2005 417.951 29.8746 387.798 29.8746Z"
              fill="#E2E1E1"
            />
            <path
              d="M363.695 171.796C343.116 171.796 326.367 153.497 326.367 130.991C326.367 108.494 343.106 90.1859 363.695 90.1859C384.275 90.1859 401.024 108.484 401.024 130.991C401.024 153.487 384.275 171.796 363.695 171.796Z"
              fill="#C1C5C5"
            />
            <path
              d="M363.695 98.9203C379.873 98.9203 393.034 113.307 393.034 130.991C393.034 148.675 379.873 163.061 363.695 163.061C347.518 163.061 334.357 148.675 334.357 130.991C334.357 113.307 347.518 98.9203 363.695 98.9203ZM363.695 81.4618C338.666 81.4618 318.386 103.641 318.386 130.991C318.386 158.351 338.676 180.52 363.695 180.52C388.725 180.52 409.005 158.341 409.005 130.991C409.005 103.641 388.715 81.4618 363.695 81.4618Z"
              fill="#5F5F5F"
            />
            <path
              d="M376.716 155.955C384.523 155.955 390.851 149.037 390.851 140.503C390.851 131.97 384.523 125.052 376.716 125.052C368.909 125.052 362.581 131.97 362.581 140.503C362.581 149.037 368.909 155.955 376.716 155.955Z"
              fill="#E2E1E1"
            />
            <path
              d="M223.552 171.796C202.972 171.796 186.224 153.497 186.224 130.991C186.224 108.494 202.963 90.1859 223.552 90.1859C244.132 90.1859 260.881 108.484 260.881 130.981C260.881 153.477 244.132 171.796 223.552 171.796Z"
              fill="#C1C5C5"
            />
            <path
              d="M223.552 98.9203C239.73 98.9203 252.891 113.307 252.891 130.991C252.891 148.675 239.73 163.061 223.552 163.061C207.375 163.061 194.214 148.675 194.214 130.991C194.214 113.307 207.375 98.9203 223.552 98.9203ZM223.552 81.4618C198.523 81.4618 178.243 103.641 178.243 130.991C178.243 158.351 198.532 180.52 223.552 180.52C248.572 180.52 268.862 158.341 268.862 130.991C268.862 103.641 248.582 81.4618 223.552 81.4618Z"
              fill="#5F5F5F"
            />
            <path
              d="M236.376 155.955C244.183 155.955 250.511 149.037 250.511 140.503C250.511 131.97 244.183 125.052 236.376 125.052C228.569 125.052 222.241 131.97 222.241 140.503C222.241 149.037 228.569 155.955 236.376 155.955Z"
              fill="#E2E1E1"
            />
            <path
              d="M426.241 422.163C430.753 421.342 434.982 419.637 437.065 417.602L490.578 365.337C493.646 362.344 490.914 359.761 484.487 359.569C478.051 359.378 470.361 361.651 467.293 364.645L413.78 416.91C410.712 419.903 413.445 422.489 419.872 422.678C421.928 422.741 424.11 422.55 426.241 422.163Z"
              fill="#5F5F5F"
            />
            <path
              d="M168.481 410.886C167.154 406.343 165.014 402.197 162.814 400.298L106.323 351.514C103.087 348.717 100.94 351.836 101.525 358.47C102.113 365.113 105.212 372.751 108.448 375.548L164.939 424.333C168.175 427.13 170.326 424.009 169.737 417.376C169.551 415.254 169.107 413.032 168.481 410.886Z"
              fill="#5F5F5F"
            />
            <path
              d="M433.407 580.807C433.407 595.276 422.681 607 409.445 607H179.011C165.775 607 155.05 595.276 155.05 580.807V328.912C155.05 314.444 165.775 302.719 179.011 302.719H409.445C422.681 302.719 433.407 314.444 433.407 328.912V580.807Z"
              fill="#E2E1E1"
            />
            <path
              d="M207.862 410.174H380.594C388.491 410.174 394.889 403.18 394.889 394.548V373.608C394.889 364.976 388.491 357.983 380.594 357.983H207.862C199.966 357.983 193.568 364.976 193.568 373.608V394.548C193.568 403.17 199.975 410.174 207.862 410.174Z"
              fill="#BCBCBB"
            />
            <path
              d="M207.862 552.505H380.594C388.491 552.505 394.889 545.511 394.889 536.879V461.372C394.889 452.74 388.491 445.746 380.594 445.746H207.862C199.966 445.746 193.568 452.74 193.568 461.372V536.879C193.568 545.521 199.975 552.505 207.862 552.505Z"
              fill="#BCBCBB"
            />
            <path
              d="M230.063 383.602V384.554C230.063 388.486 227.149 391.671 223.552 391.671C219.955 391.671 217.042 388.486 217.042 384.554V383.602C217.042 379.67 219.955 376.486 223.552 376.486C227.149 376.475 230.063 379.67 230.063 383.602Z"
              fill="#FF5322"
            />
            <path
              d="M346.151 383.602V384.554C346.151 388.486 343.237 391.671 339.64 391.671C336.043 391.671 333.13 388.486 333.13 384.554V383.602C333.13 379.67 336.043 376.486 339.64 376.486C343.228 376.475 346.151 379.67 346.151 383.602Z"
              fill="#F05432"
            />
            <path
              d="M376.716 383.602V384.554C376.716 388.486 373.803 391.671 370.206 391.671C366.609 391.671 363.695 388.486 363.695 384.554V383.602C363.695 379.67 366.609 376.486 370.206 376.486C373.803 376.475 376.716 379.67 376.716 383.602Z"
              fill="#F91B6B"
            />
            <path d="M260.073 212.942C292.6 207.074 322.625 210.497 333.572 212.942" stroke="#5F5F5F" stroke-width="7" />
            <path
              d="M463.368 71.5806C463.368 56.6749 437.566 27.5619 435.454 25.2329C435.454 25.2329 407.071 56.2089 407.071 71.5806C407.071 86.9523 419.738 99.5289 435.22 99.5289C436.158 99.5289 437.331 99.5289 438.269 99.296C438.504 99.296 438.738 99.296 438.973 99.0631C439.677 99.0631 440.38 98.8302 441.084 98.8302C441.319 98.8302 441.553 98.5974 442.022 98.5974C442.726 98.3645 443.43 98.3645 444.134 98.1316C444.368 98.1316 444.603 97.8987 444.837 97.8987C445.541 97.6658 446.245 97.433 446.948 97.2001C447.183 97.2001 447.417 96.9672 447.417 96.9672C448.121 96.7343 448.825 96.2686 449.529 95.8028C449.763 95.8028 449.763 95.5699 449.998 95.5699C450.701 95.1042 451.405 94.6384 452.109 94.1724C452.109 94.1724 452.344 94.1724 452.344 93.9395C453.047 93.4737 453.751 92.7751 454.455 92.3091C459.85 86.9523 463.368 79.7322 463.368 71.5806Z"
              fill="#3CAED6"
            />
            <path
              d="M446.949 62.2646C444.368 62.2646 442.257 64.3607 442.257 66.9227C442.257 69.4846 444.368 71.5808 446.949 71.5808C449.529 71.5808 451.64 69.4846 451.64 66.9227C451.64 64.3605 449.529 62.2646 446.949 62.2646Z"
              fill="#63BFDE"
            />
            <path
              d="M437.566 97.1998C422.084 97.1998 409.417 84.6229 409.417 69.2515C409.417 56.4418 428.652 32.9187 435.455 25.2329L435.22 25C435.22 25 407.072 56.2089 407.072 71.5806C407.072 86.9523 419.739 99.5289 435.22 99.5289C443.665 99.5289 451.171 95.8025 456.332 90.2129C451.171 94.405 444.837 97.1998 437.566 97.1998Z"
              fill="#369DC0"
            />
          </svg>
        )}
      </div>
      {loadingText && <div className="loading__text">{loadingText}</div>}
    </div>
  );
};

Loading.propTypes = {
  loadingText: PropTypes.string,
};

Loading.defaultProps = {
  loadingText: '',
};

export default Loading;
